<template>
  <p><strong>Просмотр и поиск обращений</strong></p>
  <p>Для поиска по заявкам можно воспользоваться строкой поиска: </p>
  <img src="@/assets/instruction/2.png">
  <p>Согласно подсказке, введите искомую фразу в строку поиска и нажмите клавишу ENTER</p>
  <p>Для просмотра интересующего обращения нажмите на него и откроется всплывающее окно. Пример представлен ниже:</p>
  <img src="@/assets/instruction/3.png">
  <p>В данном окне можно просмотреть существующие зарегистрированные обращения.</p>
  <p><strong>В случае, если обращение имеет статус «Решено» - обращение можно закрыть или вернуть в работу!</strong></p>
  <p><strong>В случае, если обращение создано по ошибке, есть возможность отменить его, указав причину отмены.</strong></p>
  <div class="columns">
    <div class="column is-narrow"><span class="tag is-info">Отменить обращение</span></div>
    <div class="column">Если обращение создано по ошибке, его можно отменить</div>
  </div>
  <div class="columns">
    <div class="column is-narrow"><span class="tag is-danger">Вернуть в работу</span></div>
    <div class="column">Возвращает обращение в сервисный центр ООО «ИТЦ «ГАРДИАН»</div>
  </div>
  <div class="columns">
    <div class="column is-narrow"><span class="tag is-success">Закрыть обращение</span></div>
    <div class="column">Переводит обращение в статус «Закрыто» и исключает его из списка обращений при просмотре обращений.</div>
  </div>
</template>

<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Show&Search"
}
</script>

<style scoped>
.is-info {
  background: rgb(131, 113, 119) !important;
  transition: 0.3s;
}
.is-success {
  background: rgb(45, 140, 0) !important;
  transition: 0.3s;
}
.is-danger {
  background: rgb(140, 0, 45) !important;
  transition: 0.3s;
}
</style>